import { jsx as _jsx } from "react/jsx-runtime";
import { CatButton } from '@blocks-react/components/Button';
import cx from 'classnames';
import styles from './LoginButton.module.scss';
export const LoginButton = ({ children, className, onClick, href, fullWidth = true, variant = 'primary' }) => {
    return (_jsx(CatButton, { className: className, fullWidth: fullWidth, variant: variant ?? 'primary', onClick: onClick, "data-testid": "login-button", href: href, children: _jsx("span", { className: cx(styles['login-button-label']), children: children }) }));
};
